import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { ContractorSearchInterfacePropsType } from '../..';
import { BUDGET_LIST } from './consts/budgetList';

const { tablet, mobile } = mediaQueries();

const KEY_NAME = 'SearchByBudget';
const PARAM_NAME = 'budget';

export type SearchByReviewPropsType = Merge<ContractorSearchInterfacePropsType & {
  onApplyHandler: () => void;
}>;

export const SearchByBudget = (props: SearchByReviewPropsType) => {
  const { userAnswers, commonAnswerHandler, onApplyHandler: onApplyHandlerFromProps } = props;
  const onApplyHandler = React.useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    const { value } = event.currentTarget;
    commonAnswerHandler(PARAM_NAME, value || '');

    userAnswers.push({
      keyName: 'searchByBudget',
      paramName: PARAM_NAME,
      question: '工事予算は',
      answer: value || '',
      value: value || '',
    });

    onApplyHandlerFromProps();
  }, [commonAnswerHandler, onApplyHandlerFromProps, userAnswers]);

  return (
    <div
      css={css`
        ${tablet(() => css`
          max-width: 568px;
          margin-inline: auto;
          padding: 0 1em;
        `)}
      `}
    >
      <div
        css={css`
          margin-bottom: 24px;

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            margin-bottom: ${setAutomaticDesignBasedSize(24, 20)};
          `)}
        `}
      >
        <p
          css={css`
            color: #000;
            font-size: 20px;
            font-weight: bold;

            ${mobile(({ setAutomaticDesignBasedSize }) => css`
              font-size: ${setAutomaticDesignBasedSize(20, 18)};
            `)}
          `}
        >
          工事予算から探す
        </p>
      </div>
      <div
        css={css`
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 0 20px;

          ${tablet(({ setAutomaticDesignBasedSize }) => css`
            font-size: ${setAutomaticDesignBasedSize(16, 14)};
            grid-template-columns: repeat(2, 1fr);
            gap: ${setAutomaticDesignBasedSize(20, 10)};
          `)}

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            font-size: ${setAutomaticDesignBasedSize(16, 14)};
            gap: ${setAutomaticDesignBasedSize(20, 10)};
          `)}
        `}
      >
        {BUDGET_LIST.map((budget, index) => {
          return (
            <button
              key={index}
              value={budget}
              onClick={onApplyHandler}
              id={`ga_event_${KEY_NAME}_button_${index + 1}`}
              css={css`
                color: #041156;
                font-size: 16px;
                font-weight: bold;
                text-align: center;
                padding: 21px 1em;
                background-color: #fff;
                border: 1px solid #041156;
                border-radius: 8px;

                ${mobile(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(16, 14)};
                  padding: ${setAutomaticDesignBasedSize(21, 19)} 1em;
                `)}

                &:hover {
                  background-color: #fff7c9;
                }
              `}
            >
              {budget}
            </button>
          );
        })}
      </div>
    </div>
  );
};
